<template>
    <div class="card card-info min-vh-100">
        <div class="card-header">
            <h3 class="card-title float-start">Attrezzi</h3>
            <button
                type="button"
                class="btn btn-primary float-end"
                @click="isOpen = true"
            >
                Aggiungi Attrezzo
            </button>
        </div>
        <!-- /.card-header -->
        <!-- form start -->
        <div
            class="alert alert-primary d-flex align-middle my-auto"
            role="alert"
            v-if="attrezzi.data.length == 0"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
            >
                <path
                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
            </svg>
            <div>Non sono presenti attrezzi. Creane uno per iniziare a gestirlo :)</div>
        </div>
        <table class="table" v-if="attrezzi.data.length > 0">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nome</th>
                    <th scope="col">Descrizione</th>
                    <th scope="col">Azioni</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="attrezzo in attrezzi.data" :key="attrezzo.id">
                    <th scope="row">{{ attrezzo.id }}</th>
                    <td>{{ attrezzo.nome }}</td>
                    <td>{{ attrezzo.descrizione }}</td>
                    <td>
                        <delete-button
                            :id="attrezzo.id"
                            @click="confirnDelete(attrezzo)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination :links="attrezzi.links" />
    </div>
    <Create
        v-if="isOpen"
        @modelStatusChanged="modalStatus"
        :attrezzo="attrezzo"
        :isEdit="isEdit"
    />
    <Show
        v-if="isShow"
        :attrezzo="attrezzo"
        :isShow="isShow"
        @modelShowChanged="modalShow"
    />
    <confirm-box
        v-if="showConfirmBox"
        :confirmed="deleteAttrezzo"
        @hidden="showConfirmBox = false"
        heading="Attenzione!"
        :message="deleteConfirmation"
        confirmText="Si"
        cancelText="No"
    />
</template>
<script>
import Main from "@/Layouts/Main.vue";
import Create from "@/Pages/Attrezzo/Form.vue";
import Show from "@/Pages/Attrezzo/Show.vue";
import ShowButton from "@/Components/ShowButton.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        attrezzi: Object,
        flash: Object,
    },
    components: {
        Create,
        Show,
        ShowButton,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
    },
    data() {
        return {
            attrezzo: null,
            isOpen: false,
            isShow: false,
            isEdit: false,
            showConfirmBox: false,
        };
    },
    methods: {
        show(attrezzo) {
            this.attrezzo = attrezzo;
            this.isShow = true;
        },
        edit(attrezzo) {
            this.attrezzo = attrezzo;
            this.isEdit = true;
            this.isOpen = true;
        },
        confirnDelete(attrezzo) {
            this.attrezzo = attrezzo;
            this.showConfirmBox = true;
        },
        modalStatus(status) {
            this.isOpen = status;
        },
        modalShow(status) {
            this.isShow = status;
        },
        hideConfirmation() {
            this.showConfirmBox = false;
        },
        deleteAttrezzo() {
            this.$inertia.delete(
                this.route("attrezzo.destroy", this.attrezzo.id)
            );
        },
    },

    computed: {
        deleteConfirmation() {
            return `Sei sicuro di voler eliminare ${this.attrezzo.nome}?`;
        },
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>
